module.exports = __webpack_public_path__ + "img/a4.c288c80b.png";